import { SelectOptionElement } from '@odin-labs/components';
import { ProcoreProjectVendor } from 'apollo/generated/client-operations';
import { JobsiteForOption, JobsiteOptionElement } from './types';

export const getJobsitesOptions = (
  jobsites: JobsiteForOption[],
): JobsiteOptionElement[] =>
  jobsites
    ?.map(({ jobsiteId: value, name: label, startDate }) => ({
      value,
      label,
      startDate,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

export const getProcoreProjectVendorOptions = (
  procoreProjectVendors: ProcoreProjectVendor[],
): SelectOptionElement[] =>
  procoreProjectVendors?.map(({ id: value, name: label }) => ({
    value,
    label,
  })) ?? [];
